module.exports = __webpack_public_path__ + "img/GL.dbadefbf.png";